/*
 * @Author: lixin jiang
 * @Date: 2021-09-22 13:55:43
 * @LastEditTime: 2023-04-07 16:03:53
 * @LastEditors: guorui.teng 704386484@qq.com
 * @Description:
 * @FilePath: /kitchen-online-web/src/utils/track.js
 * @
 */

const pageConfig = {
  'homepage/stepone': {
    pageType: 'kit_adjustment_1/5_1',
    pageName: '1/5柜型尺寸选择_形状',
  },
  'homepage/steptwo': {
    pageType: 'kit_adjustment_1/5_2',
    pageName: '1/5柜型尺寸选择_尺寸',
  },
  'homepage/stepthree': {
    pageType: 'kit_adjustment_1/5_3',
    pageName: '1/5柜型尺寸选择_位置',
  },
  'home/doorPlank': {
    pageType: 'kit_adjustment_2/5',
    pageName: '2/5门板选择',
  },
  'home/mesa': {
    pageType: 'kit_adjustment_3/5',
    pageName: '3/5台面选择',
  },
  'home/storage': {
    pageType: 'kit_adjustment_4/5',
    pageName: '4/5内配储物',
  },
  'home/offer': {
    pageType: 'kit_offer',
    pageName: '5/5厨房设计报价',
  },
};

export function getPageInfo() {
  const { href } = window.location;
  const key = Object.keys(pageConfig).find((item) => href.includes(item)) || 'stepone';
  return pageConfig[key];
}

export default function gioTrack(type, parameter) {
  // eslint-disable-next-line no-undef
  const pageInfo = getPageInfo();
  // eslint-disable-next-line no-undef
  return gio('track', type, {
    pageType_var: pageInfo.pageType,
    pageName_var: pageInfo.pageName,
    ...parameter,
  });
}
